import React from "react";
import Review1 from "../assets/images/reviews/Review1.png";
import Review2 from "../assets/images/reviews/Review2.png";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const RegistrationReviews: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <img src={Review1} alt='Review 1' height={180} className={classes.item} />
      <img src={Review2} alt='Review 2' height={180} className={classes.item} />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    borderRadius: "16px",
    maxWidth: "378px",
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "32px",
  },
}));

export default RegistrationReviews;
